import React from 'react';
// STYLE
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
// COMPONENTS
import ViewMyRequestModalInputs from './ViewMyRequestModalInputs/ViewMyRequestModalInputs';

const ViewMyRequestModal = props => {
  const { requestData, handleClose } = props;
  const open = !!requestData;

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>Előjegyzésem adatai</DialogTitle>
      <DialogContent>
        <ViewMyRequestModalInputs requestData={requestData} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Bezárás
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewMyRequestModal;
